import React from 'react';
import {connect} from 'react-redux';
import qs from 'qs';


class Stats extends React.PureComponent {
    render(){
        const {log} = this.props.stats

        const account_id = this.props.account_id || this.props.stats.log.account_id || localStorage.getItem('lzwk_id')

        const params = Object.assign({}, log, {account_id},
        {
            'props_account_id': this.props.account_id,
            'stats_account_id':this.props.stats.log.account_id,
            'lzwk_id': localStorage.getItem('lzwk_id'),
            'v': '111',
        })

        if(params.action){
            const query = qs.stringify(params)
            const src = 'https://stat.lizhiweike.com/__t.gif?' + query
            return <img id="stat_img" style={{display: 'none'}} src={src} alt="" />
        }
        return null
    }
}


export default connect( state =>( {stats: state.stats, account_id: state.account.id} ) )(Stats)



// WEBPACK FOOTER //
// ./src/components/Stats.js